<template>
  <Spinner v-if="!billingEntitlementsReady"/>

  <slot v-else-if="canUseFeature"/>

  <BillingFeatureNotice v-else
                        :feature="feature"
                        :variant="variant"
                        :title="title"
                        :description="description"
                        :icon="icon"
                        :open-in-new-tab="openInNewTab"/>
</template>

<!--WITHOUT SPINNER!-->
<!--<template>-->
<!--  <slot-->
<!--      v-if="billingEntitlementsReady && canUseFeature"-->
<!--  />-->

<!--  <BillingFeatureNotice-->
<!--      v-else-if="billingEntitlementsReady"-->
<!--      :feature="feature"-->
<!--      :variant="variant"-->
<!--      :title="title"-->
<!--      :description="description"-->
<!--      :icon="icon"-->
<!--  />-->
<!--</template>-->

<script>
import BillingFeatureNotice from '@/components/billing/BillingFeatureNotice.vue'

export default {
  name: 'BillingFeatureGate',

  components: {
    BillingFeatureNotice,
  },

  props: {
    feature: {
      type: String,
      required: true,
    },

    variant: {
      type: String,
      default: 'compact',
      validator: value => ['compact', 'page'].includes(value),
    },

    title: {
      type: String,
      default: '',
    },

    description: {
      type: String,
      default: '',
    },

    icon: {
      type: String,
      default: 'ti-lock',
    },

    openInNewTab: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    billingEntitlementsReady() {
      return this.$store.getters.billingEntitlementsReady
    },

    canUseFeature() {
      return this.$store.getters.canUse(this.feature)
    },
  },
}
</script>